/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createSplitPeriodCalculationGetResponseFromDiscriminatorValue, type SplitPeriodCalculationGetResponse } from '../../../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/splits/{splitId}/calculation
 */
export interface CalculationRequestBuilder extends BaseRequestBuilder<CalculationRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SplitPeriodCalculationGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SplitPeriodCalculationGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CalculationRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/splits/{splitId}/calculation";
/**
 * Metadata for all the requests in the request builder.
 */
export const CalculationRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CalculationRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        adapterMethodName: "send",
        responseBodyFactory:  createSplitPeriodCalculationGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
